//...
import * as Sentry from '@sentry/react'

if (!window.location.host.startsWith('localhost')) {
  Sentry.init({
    // DSN copied from https://sentry.io/settings/clx-communications-cg/projects/livechat/keys/
    dsn: import.meta.env.PUBLIC_FWDPAGE_SENTRY_DSN,
    release: `forwarding-page@${import.meta.env.APP_VERSION}`,
    integrations: [Sentry.browserTracingIntegration()],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [],
    // Session Replay
    replaysSessionSampleRate: 0.1, // (default=0.1) This sets the sample rate at x%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1, // (default=1.0) If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })
}
